var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", width: 12.849, height: 7.024 }, props), /* @__PURE__ */ React.createElement("path", { d: "m6 6.849-6-6L.849 0l5.575 5.576L12 0l.849.849-6 6a.6.6 0 0 1-.849 0Z", fill: "#1E2226" }));
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHdpZHRoPSIxMi44NDkiIGhlaWdodD0iNy4wMjQiPjxwYXRoIGQ9Im02IDYuODQ5LTYtNkwuODQ5IDBsNS41NzUgNS41NzZMMTIgMGwuODQ5Ljg0OS02IDZhLjYuNiAwIDAgMS0uODQ5IDBaIiBmaWxsPSIjMUUyMjI2Ii8+PC9zdmc+";
